import { CartAddEvent } from '@theme/events';

/**
 * One-tap "add to cart" for the suggestions in the cart drawer.
 * Adds the variant, then dispatches the theme's cart add event with the re-rendered drawer section,
 * so the drawer, cart count and totals update the same way as a normal add to cart.
 */
class CartUpsell extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-variant-id]') : null;
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    const sectionId = this.closest('cart-items-component')?.getAttribute('data-section-id');
    const root = window.Shopify?.routes?.root ?? '/';

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
          ...(sectionId ? { sections: sectionId, sections_url: window.location.pathname } : {}),
        }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Add to cart failed');

      document.dispatchEvent(
        new CartAddEvent({}, 'cart-upsell', {
          source: 'product-form-component',
          itemCount: 1,
          productId: button.dataset.productId,
          variantId: button.dataset.variantId,
          sections: data.sections,
        })
      );
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('cart-upsell')) {
  customElements.define('cart-upsell', CartUpsell);
}
